import { render, staticRenderFns } from "./NotificationInRoomMatch.vue?vue&type=template&id=107301bc&scoped=true&"
import script from "./NotificationInRoomMatch.vue?vue&type=script&lang=js&"
export * from "./NotificationInRoomMatch.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInRoomMatch.vue?vue&type=style&index=0&id=107301bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107301bc",
  null
  
)

export default component.exports